<template>
    <div>
        <section class="totalizers-container">
            <div class="totalizers-list">
                <totalizer-block
                    :text="translate('messages.total_registered_warehouses')"
                    :number="totalizers.totalizerActive"
                    iconClass="lyra-icon lyra-volume-armazenado"
                    :noIconTotalizer="false"
                />
                <totalizer-block
                    :text="translate('messages.displaced_volume')"
                    :number="formatTextTotalizerRow(totalizers.soldVolume, 't')"
                    iconClass="lyra-icon lyra-volume-vendido"
                    :noIconTotalizer="false"
                />
                <totalizer-block
                    :text="translate('messages.total_available_capacity')"
                    :number="formatTextTotalizerRow(totalizers.totalAvailableCpacity, 't')"
                    iconClass="lyra-icon lyra-armazem"
                    :noIconTotalizer="false"
                />
                <totalizer-block
                    :text="translate('messages.batches_in_processing')"
                    :number="totalizers.batchesInProcessing"
                    iconClass="lyra-icon lyra-processamento-documento"
                    :noIconTotalizer="false"
                    :routeName="'ProcessamentoNotasLote'"
                />
            </div>

        </section>

    </div>
</template>

<script>
import TotalizerBlock from '@/modules/warehouse/views/components/TotalizerBlock.vue';
import warehouseService from '@/services/ArmazemModuleService';
import formatters from '@/utils/formatters';

import { mapState } from 'vuex';
import { MainPageTabs } from '@/modules/warehouse/constants/MainPageTabsEnum';

export default {
    name: 'WarehouseDefault',
    components: { TotalizerBlock },
    props: {
        value: {
            type: Object,
            default: () => ({
                warehouse_id: ''
            })
        },
        filters: {
            type: Object,
            required: false,
            default: () => null
        },
        secondRowData: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            tabName: MainPageTabs.WAREHOUSES_TAB,
            hasLoaded: false,
            totalizers: {
                soldVolume: '-',
                totalAvailableCpacity: '-',
                batchesInProcessing: '-',
                totalizerActive: '-'
            }
        };
    },
    computed: {
        ...mapState('warehouseModule', ['selectedTab'])
    },
    mounted() {
        if (this.selectedTab === this.tabName && !this.hasLoaded) {
            this.getTotalizers();
        }
    },
    watch: {
        selectedTab: {
            handler(newVal) {
                if (this.selectedTab === this.tabName && !this.hasLoaded) {
                    this.getTotalizers();
                }
            }
        }
    },
    methods: {
        translate(key, params = {}) {
            const base = 'warehouse';
            return this.$t(`${base}.${key}`, params);
        },
        async getTotalizers() {
            this.hasLoaded = true;
            await warehouseService.getTotalizers().then(({ data }) => {
                this.totalizers.totalizerActive = data.totalArmazem;
                this.totalizers.totalAvailableCpacity = data.saldoAtualTon;
                this.totalizers.soldVolume = data.saldoTransitoTon;
                this.totalizers.batchesInProcessing = data.totalProcessamento;
            });
        },
        formatTextTotalizerRow(data, text) {
            if (!data || data === '') {
                return null;
            } else if (data === '-') {
                return data;
            } else {
                return formatters.minFormatNumber(data, 3, this.$i18n.locale) + (!text ? '' : (' ' + text));
            }
        }
    }
};
</script>

<style scoped lang="scss">
.totalizers-container {
    h3 {
        margin-bottom: 10px;
        margin-top: 10px;
        color: var(--black);
        font-weight: 500;
    }

    .totalizers-list {
        width: 100%;
        display: grid;
        column-gap: 16px;
        grid-template-columns: 1fr 1fr 1fr 1fr;
    }
}
</style>
